import apiClient from './apiClient';

export interface QueryParams {
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  product_from?: string;
  product_to?: string;
  item_spec_from?: string;
  item_spec_to?: string;
  process_from?: string;
  process_to?: string;
}

export interface ReportRow {
  FD130_15: string;       // vendor code
  vendor_name: string;
  item_combo: string;     // color-spec combination
  FD130_12: string;       // product code
  unit_price: number;
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: VendorCount[];
  message?: string;
}

export const d320Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d320/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d320/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
